import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';
import organizationService from '../services/organizationService';

const organizationCollectionName = 'organizations_master_data';
export const useOrganization = () => {
  return useQuery({
    queryKey: [organizationCollectionName],
    queryFn: () => organizationService.getAll(),
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};

export const useAddOrganization = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: organizationService.add,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [organizationCollectionName] });
    },
  });
};

export const useEditOrganization = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: organizationService.edit,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [organizationCollectionName] });
    },
  });
};

export const useDeleteOrganization = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: organizationService.delete,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [organizationCollectionName] });
    },
  });
};

export const useOrganizationNameById = (organizationId) => {
  return useQuery({
    queryKey: [organizationCollectionName, organizationId],
    queryFn: () => organizationService.getNameById(organizationId),
    enabled: !!organizationId, // only run when organizationId is truthy
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};

export const useGetAPONumberById = (organizationId) => {
  return useQuery({
    queryKey: [organizationCollectionName, organizationId],
    queryFn: () => organizationService.getAPONumberById(organizationId),
    enabled:!!organizationId, // only run when organizationId is truthy
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
}